import { ComponentProps, useEffect, useState } from 'react';

import { Copy } from '@phosphor-icons/react';
import { twMerge } from 'tailwind-merge';
import { cva } from 'class-variance-authority';

const CopyButtonStyles = cva(
  [
    'transition-all',
    'duration-300',
    'w-6',
    'h-6',
    'flex-shrink-0',
    'grid',
    'place-items-center',
    'relative'
    // 'before:absolute',
    // 'before:inset-0',
    // 'before:bg-black',
    // 'before:w-[1px]',
    // 'before:h-3/4',
    // 'before:left-0',
    // 'before:top-[12.5%]'
  ],
  {
    variants: {
      copied: {
        true: 'bg-green-400 text-white',
        false: 'bg-white'
      }
    },
    defaultVariants: {
      copied: false
    }
  }
);

export function Code(props: ComponentProps<`code`>) {
  const { className, ...rest } = props;
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 1000);
    }
  }, [copied]);
  return (
    <div
      className={twMerge(
        'bg-white p-0 self-baseline border-black border text-neutral-800 inline-flex flex-row w-auto items-center gap-2 relative text-xs flex-grow-0',
        className
      )}
    >
      <code {...rest} />
      <div className="flex-grow self-stretch flex flex-col justify-start border-l border-black ">
        <button
          className={CopyButtonStyles({ copied })}
          onClick={() => {
            navigator.clipboard.writeText(rest.children as string);
            setCopied(true);
          }}
        >
          <Copy />
        </button>
      </div>
    </div>
  );
}
